import { AuthUserPermission, Can, useWindowTitle } from '@cibo/profile'
import { TabPanel, Tabs } from '@cibo/ui'
import AddCircleOutlineRounded from '@mui/icons-material/AddCircleOutlineRounded'
import { Button, Stack, Tab, Typography } from '@mui/material'
import {
  CreateErrorReportDialog,
  PaginatedAgreementsTable,
  usePaginatedAgreementsTableColumns,
} from 'features/Agreements'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

export const ErrorReports = () => {
  const { t } = useTranslation('impact/pages/Admin/AgreementsOverview')
  useWindowTitle(t('title', { context: 'error-report' }))
  const [showDialog, setShowDialog] = useState(false)

  const [params, setParams] = useSearchParams({ t: 'pending' })
  const {
    acres,
    dateAgreed,
    dateDeclined,
    offerUsd,
    programs,
    status,
    userId,
    year,
  } = usePaginatedAgreementsTableColumns()

  const pendingColumns = useMemo(() => [status, year, userId, programs, offerUsd, acres], [])
  const declinedColumns = useMemo(
    () => [status, year, userId, programs, offerUsd, acres, dateDeclined],
    []
  )
  const agreedColumns = useMemo(
    () => [status, year, userId, programs, offerUsd, acres, dateAgreed],
    []
  )

  return (
    <>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
        <Typography variant="h5">{t('title', { context: 'error-report' })}</Typography>
        <Can useAny={AuthUserPermission.AGREEMENTS_ADMIN_REVIEW_CREATE}>
          <Button
            onClick={() => setShowDialog(true)}
            variant="contained"
            size="small"
            startIcon={<AddCircleOutlineRounded />}
            data-testid="create-error-report-button"
          >
            {t('createErrorReport')}
          </Button>
        </Can>
      </Stack>

      <Tabs
        value={params.get('t')}
        onChange={(event, newTab) => setParams({ t: newTab }, { replace: true })}
      >
        <Tab value={'pending'} label={t('tab', { context: 'pending' })} />
        <Tab value={'declined'} label={t('tab', { context: 'declined' })} />
        <Tab value={'agreed'} label={t('tab', { context: 'agreed' })} />
      </Tabs>
      <TabPanel currentValue={params.get('t')} value={'pending'}>
        <PaginatedAgreementsTable
          baseQuery={{
            agreementType: 'adminReview',
            status: 'pending',
          }}
          columns={pendingColumns}
          includeStats
        />
      </TabPanel>
      <TabPanel currentValue={params.get('t')} value={'declined'}>
        <PaginatedAgreementsTable
          baseQuery={{
            agreementType: 'adminReview',
            status: 'declined',
          }}
          columns={declinedColumns}
          includeStats
        />
      </TabPanel>
      <TabPanel currentValue={params.get('t')} value={'agreed'}>
        <PaginatedAgreementsTable
          baseQuery={{
            agreementType: 'adminReview',
            status: 'agreed',
          }}
          columns={agreedColumns}
          includeStats
        />
      </TabPanel>
      <CreateErrorReportDialog open={showDialog} onClose={() => setShowDialog(false)} />
    </>
  )
}
